import { jsx as _jsx } from "react/jsx-runtime";
import { Close, Check } from '@mui/icons-material';
import { Dialog } from 'components/custom';
import { Button } from 'components/custom';
import { useTranslation } from 'react-i18next';
const ConfirmationDialog = (props) => {
    const { t } = useTranslation('common');
    const { cancelButtonProps, confirmButtonProps, ...cmpProps } = props;
    const { children: cancelButtonChildren = t('body.dialog.actions.cancel'), ...restCancelButtonProps } = cancelButtonProps;
    const { children: confirmButtonChildren = t('body.dialog.actions.save'), ...restConfirmButtonProps } = confirmButtonProps;
    return (_jsx(Dialog, { ...cmpProps, actions: [
            _jsx(Button, { "data-testid": "cancel", fullWidth: true, variant: "contained", color: "error", startIcon: _jsx(Close, {}), ...restCancelButtonProps, children: cancelButtonChildren }, "cancel"),
            _jsx(Button, { "data-testid": "confirm", fullWidth: true, variant: "contained", color: "secondary", startIcon: _jsx(Check, {}), ...restConfirmButtonProps, children: confirmButtonChildren }, "confirm"),
        ] }));
};
export default ConfirmationDialog;
